import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ChargeAccountService } from 'src/app/angularJS/services/charge-account/charge-account.service';

/**
 * A Controller using the {@link actora.services.customerService} to handle the retrieval and display of customer charge account controller detail.
 */
export class ChargeAccountListController {

  public static $inject = ['$rootScope', 'customerService', 'PrimaryAction', 'customer', '$state', 'activeChargeAccounts', 'UserMessages', 'chargeAccountService'];
  public activeChargeAccountList: Array<InterACT.Interfaces.IChargeAccountList>;
  public noActiveChargeAccount: boolean;

  constructor(
    private $rootScope,
    private customerService: CustomerService,
    private PrimaryAction: any,
    private customer: InterACT.Interfaces.Customers.Customer,
    private $state: ng.ui.IStateService,
    private activeChargeAccounts: Array<InterACT.Interfaces.ChargeAccounts.ChargeAccount>,
    private UserMessages: UserMessagesService,
    private chargeAccountService: ChargeAccountService
  ) {
    this.activeChargeAccountList = [];
    this.noActiveChargeAccount = false;
    this.activate();
  }

  /**
   * A method which is used to showDialog and close charge account
   */
  public showConfirmDialog = (activeChargeAccount: InterACT.Interfaces.IChargeAccountList) => {
    return this.UserMessages.buildConfirmDialog(
      'CONFIRM_DIALOG.CHARGE_ACCOUNT.CLOSE_THIS',
      'CONFIRM_DIALOG.CHARGE_ACCOUNT.CLOSE',
      { account: activeChargeAccount.chargeAccount.usageTokens[0].mediaLink.reference.slice(-4) },
      'CONFIRM_DIALOG.CHARGE_ACCOUNT.CONFIRM',
      'CONFIRM_DIALOG.CUSTOMER.CANCEL')
      .then(() => {
        this.closeAccount(activeChargeAccount);
      });
  }

  /**
   * Function to close a charge account from the Customer backend service
   *
   * @param chargeAccount The chargeAccount model representing the record on the server to be deleted.
   */
  private closeAccount = (activeChargeAccount: InterACT.Interfaces.IChargeAccountList) => {
    activeChargeAccount.chargeAccount.status = <any>'BLOCKED';
    this.chargeAccountService.updateChargeAccount(activeChargeAccount.chargeAccount.id, activeChargeAccount.chargeAccount)
      .then((value) => {
        this.UserMessages.showToast('TOAST_MESSAGE.CHARGE_ACCOUNT.CLOSE_SUCCESS');
      },
        (error) => {
          this.UserMessages.showToast('TOAST_MESSAGE.CHARGE_ACCOUNT.CLOSE_ERROR');
          activeChargeAccount.chargeAccount.status = <any>'ACTIVE';
        });
  }

  /**
   * A method which is used initialize controller and load required data.
   */
  private activate() {
    this.setActiveChargeAccounts();
    this.PrimaryAction.setActions([{
      name: 'Add',
      icon: 'add',
      action: this.goToAddChargeAccount
    }]);
  }

  /**
   * A method which is used to go to the add charge account screen.
   */
  private goToAddChargeAccount = () => {
    this.$state.go('customer.chargeAccount.add');
  }

  /**
    * call charge account to get active charge account for a customer.
    */
  private setActiveChargeAccounts = () => {
    const activeChargeAccounts: Array<InterACT.Interfaces.ChargeAccounts.ChargeAccount> = [];
    if (angular.isDefined(this.activeChargeAccounts) && this.activeChargeAccounts.length > 0) {
      this.setChargeAccountDetails(this.activeChargeAccounts.filter((chargeAccount) => {
        return chargeAccount.usageTokens[0];
      }));
    } else {
      this.noActiveChargeAccount = true;
    }
  }

  /**
   * Set complete info for charge account with card details which is associated to the customer
   *
   *  @param activeChargeAccounts A list of all the active charge accounts details
   */
  private setChargeAccountDetails = (activeChargeAccounts: Array<InterACT.Interfaces.ChargeAccounts.ChargeAccount>) => {
    activeChargeAccounts.forEach((chargeAccount) => {
      const cardId = chargeAccount.usageTokens[0].mediaLink.link.split('/')[2];
      this.$rootScope.showSpinner = true;
      this.customerService.getCards('id=' + cardId).then((associatedCards) => {
        if (associatedCards.length > 0) {
          this.activeChargeAccountList.push({
            card: associatedCards[0],
            chargeAccount: chargeAccount,
            balance: this.calculateBalance(chargeAccount),
            remainingCharges: this.calculateRemainingCharges(chargeAccount),
            isItsoCard: this.isItsoCard(associatedCards[0])
          });
          this.noActiveChargeAccount = false;
        }
        if (this.activeChargeAccountList.length === 0) {
          this.noActiveChargeAccount = true;
        }
        this.$rootScope.showSpinner = false;
      });
    });
  }

  /**
  * A method to calculate the Remaining Charges by subtraction over unsettledCharges - unsettledRefunds
  * of an active charge account.
  *
  * @param chargeAccount Active charge account
  *
  * @returns the Remaining Charges
  */
  private calculateRemainingCharges(chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount) {
    let remainingCharges = 0;
    if (angular.isDefined(chargeAccount.unsettledCharges)) {
      remainingCharges += chargeAccount.unsettledCharges.amount;
    }
    if (angular.isDefined(chargeAccount.unsettledRefunds)) {
      remainingCharges -= chargeAccount.unsettledRefunds;
    }
    return remainingCharges;
  }

  /**
    * A method to calculate the total balance by subtraction over creditBalance - outstandingDebt
    * of an active charge account.
    *
    * @param chargeAccount Active charge account
    *
    * @returns the total balance
    */
  private calculateBalance(chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount) {
    let balance = 0;
    if (angular.isDefined(chargeAccount.creditBalance)) {
      balance += chargeAccount.creditBalance;
    }
    if (angular.isDefined(chargeAccount.outstandingDebt)) {
      balance -= chargeAccount.outstandingDebt.amount;
    }
    return balance;
  }

  /**
   * A method to validate card type is ITSO or not of active charge account.
   *
   * @param card The card to want to find is of type itso
   *
   * @returns true if the card passed in is a type of itso
   */
  private isItsoCard(card: InterACT.Interfaces.Cards.Card) {
    return card.cardApplications.indexOf('ITSO') !== -1;
  }
}
